export default "__VITE_ASSET__ibs6auzB__"